import { useEffect, useRef } from "react";
import { useAuth } from "@/providers/AuthProvider";
import { API_CONFIG } from "@/config/api";

declare global {
  interface Window {
    oc?: { renderUnloadedComponents?: () => void };
  }
}


interface FeatureFeedbackProps {
  feature: string;
  accountToken?: string;
  apiHost?: string;
  customerName?: string;
  userId?: string;
  product?: string;
  reDisplayAfterDays?: number;
  theme?: "light" | "dark";
  dismissible?: boolean;
  language?: string;
}

export function FeatureFeedback({
  feature,
  accountToken = API_CONFIG.sentimentAccountToken,
  apiHost = API_CONFIG.sentimentApiHost,
  customerName,
  userId,
  product = "Cash Forecaster",
  reDisplayAfterDays = API_CONFIG.sentimentRedisplayDays,
  theme = "light",
  dismissible = true,
  language = "en-GB",
}: FeatureFeedbackProps) {
  const { evoUserInfo } = useAuth();
  const resolvedUserId = userId ?? evoUserInfo?.userId ?? "";
  const resolvedCustomerName = customerName ?? evoUserInfo?.customerName ?? "";
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const params = new URLSearchParams({
      feature,
      accountToken,
      apiHost,
      customerName: resolvedCustomerName,
      userId: resolvedUserId,
      product,
      reDisplayAfterDays: reDisplayAfterDays.toString(),
      theme,
      dismissible: dismissible.toString(),
      language,
    });

    const registryBase = API_CONFIG.mfeRegistryBase;
    const componentUrl = `${registryBase}/evo-feature-feedback-collector/1/?${params}`;

    const ocComponent = document.createElement("oc-component");
    ocComponent.setAttribute("href", componentUrl);

    container.innerHTML = "";
    container.appendChild(ocComponent);

    window.oc?.renderUnloadedComponents?.();

    return () => {
      container.innerHTML = "";
    };
  }, [feature, accountToken, apiHost, resolvedCustomerName, resolvedUserId, product, reDisplayAfterDays, theme, dismissible, language]);

  return <div ref={containerRef} />;
}
